<template>
    <div class="row mt-3">
        <div class="col-xl-6 col-lg-12">
            <div class="mb-3">
                <strong>Thống kê tỉ lệ hoàn thành</strong>
            </div>
            <div class="chart-complete-ratio">
                <div class="display-flex-center justify-content-center">
                    <h5 class="text-subtitle">Biểu đồ tỉ lệ hoàn thành của học sinh</h5>
                </div>
                <ChartCompleteRatio :classSchoolId="classSchoolId" :lessonClassSchoolId="lessonClassSchoolId"
                    :type="'ElectronicLecture'" />
            </div>
        </div>
        <div class="col-xl-6 col-lg-12">
            <div class="mb-3">
                <label class="text-subtitle m-0">Danh sách học sinh</label>
                <b-table responsive striped hover sticky-header :fields="fieldsTableMember" :items="listMember"
                    class="b-table-list">
                    <template #head(stt)="data">
                        <span class="col-table">{{ data.label }}</span>
                    </template>
                    <template #head(name)="data">
                        <span class="col-table">{{ data.label }}</span>
                    </template>
                    <template #cell(stt)="row">
                        {{ row.item.stt }}
                    </template>
                    <template #cell(memberName)="row">
                        {{ row.item.memberName }}
                    </template>
                    <template #cell(completeRate)="row">
                        {{ row.item.completeRate != null ? formatCompleteRate(row.item.completeRate) + '%' : '-' }}
                    </template>
                    <template #table-caption v-if="listMember.length == 0">Chưa có dữ liệu học sinh</template>
                </b-table>
            </div>

        </div>
    </div>
</template>
<script>
import moment from "moment"
import vueCustomScrollbar from 'vue-custom-scrollbar'
import ChartCompleteRatio from './ChartCompleteRatio'
import { getListUserElectroniclecture } from './../../_api/lessonClassSchoolUserServices';

export default {
    components: {
        vueCustomScrollbar,
        ChartCompleteRatio
    },
    props: {
        listGroupId: {
            type: Number,
            default: 0
        },
        classSchoolId: {
            type: Number,
            default: 0
        },
        lessonClassSchoolId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            paramQueryDataMember: {
                keyword: '',
                pageIndex: 1,
                pageSize: 5000000,
                subjectId: 0,
                classId: 0,
                classSchoolId: 0,
                lessonClassSchoolId: 0
            },
            fieldsTableMember: [
                { key: 'stt', label: 'STT', thClass: 'w-70px text-center', tdClass: 'w-70px text-center' },
                { key: 'memberName', label: 'Tên học sinh', thClass: 'text-center', tdClass: 'text-center' },
                { key: 'completeRate', label: 'Tiến độ hoàn thành', thClass: 'w-200px text-center', tdClass: 'w-200px text-center' },
            ],
            listMember: [],
        }
    },
    watch: {
        'classSchoolId': 'getListMember',
    },
    mounted() {
        if (this.classSchoolId > 0) {
            this.getListMember()
        }
    },
    methods: {
        moment,
        formatNumber(value) {
            if (typeof value !== 'number') {
                return value;
            }
            if (value % 1 == 0.5) {
                return value.toFixed(1);
            }
            return value.toFixed(0);
        },
        formatCompleteRate(value) {
            if (typeof value !== 'number') {
                return value;
            }
            return Number(value.toFixed(2));
        },
        getListMember() {
            this.listMember = []
            this.paramQueryDataMember.classSchoolId = this.classSchoolId
            this.paramQueryDataMember.lessonClassSchoolId = this.lessonClassSchoolId
            getListUserElectroniclecture(this.paramQueryDataMember).then(res => {
                if (res && res.data && !res.errors && res.data.list != null) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        this.listMember.push({
                            'stt': i + 1,
                            'memberName': item.userName,
                            'completeRate': item.completeRate,
                            'lessonClassSchoolUserId': item.lessonClassSchoolUserId,
                        })
                    }
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.chart-complete-ratio {
    padding: 0.5rem 2rem;
    border: 1px solid #dee2e6;
    border-radius: 0.6rem;
    min-height: 10rem;
}

.header-table .col-header {
    color: #94a3b0;
    padding: 0.3rem 1rem;
}

.col-cell {
    padding: 0.3rem 1rem;
}

.icon-edit {
    width: 15px;
    cursor: pointer;
}

.width-60 {
    width: 60px;
}
</style>